import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["inputField", "textDisplay"];

  connect() {
    this.blockId = this.element.dataset.blockId;
    this.blockType = 'text_input';
    this.isReadOnly = this.data.get("readOnly") === "true";

    if (this.hasInputFieldTarget) {
      this.inputFieldTarget.addEventListener("keypress", this.handleKeyPress.bind(this));
    }

    this.saveTimeout = null;
  }

  edit(event) {
    if (this.isReadOnly) return;

    // Mark this block as actively being edited
    window.activeEditingManager.startEditing(this.blockId, this.blockType, this.element);

    if (this.saveTimeout) {
      clearTimeout(this.saveTimeout);
      this.saveTimeout = null;
    }

    const displayElement = this.textDisplayTarget;
    const inputElement = this.inputFieldTarget;

    displayElement.style.display = "none";
    inputElement.style.display = "block";
    inputElement.focus();
  }

  handleKeyPress(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.inputFieldTarget.blur();
    }
  }

  save(event) {
    if (event.type === "keydown" && event.key !== "Enter") return;

    this.scheduleSave();
  }

  scheduleSave() {
    clearTimeout(this.saveTimeout);
    this.saveTimeout = setTimeout(() => this.performSave(), 3000);
  }

  performSave() {
    if (!this.hasInputFieldTarget || !this.hasTextDisplayTarget) return;

    const inputElement = this.inputFieldTarget;
    const displayElement = this.textDisplayTarget;
    const newValue = inputElement.value.trim();

    const { accountId, projectId, taskListId, taskId, blockId } = this.element.dataset;

    fetch(`/${accountId}/projects/${projectId}/task_lists/${taskListId}/tasks/${taskId}/task_blocks/${blockId}/update_content`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        task_block: { value: newValue },
        skip_broadcast: false 
      })
    })
      .then(response => {
        if (response.status === 404) {
          return response.json().then(data => {
            throw new Error(data.error || 'Task block does not exist or has been deleted');
          });
        }
        return response.json();
      })
      .then(data => {
        if (data.success) {
          displayElement.textContent = data.value || "Click to edit";
          // Stop editing after successful save
          window.activeEditingManager.stopEditing(this.blockId, 500);
        } else {
          console.error("Failed to save text input:", data);
          
          if (data.error) {
            alert(data.error);
          }
          // Stop editing even on error
          window.activeEditingManager.stopEditing(this.blockId, 1000);
        }
      })
      .catch(error => {
        console.error("Error updating block:", error);
        alert(error.message || "This field has been deleted. Please refresh the page.");
        // Stop editing on error
        window.activeEditingManager.stopEditing(this.blockId, 1000);
      })
      .finally(() => {
        if (this.hasInputFieldTarget) inputElement.style.display = "none";
        if (this.hasTextDisplayTarget) displayElement.style.display = "flex";
      });
  }

  disconnect() {
    if (this.saveTimeout) clearTimeout(this.saveTimeout);
    if (this.blockId) window.activeEditingManager.stopEditing(this.blockId, 0);
  }
}
